import * as React from "react"
import { useState, useEffect } from "react"


import {
  UserIcon,
  CashIcon,
  XCircleIcon,
  ExclamationCircleIcon,
  CheckCircleIcon
} from '@heroicons/react/solid'


import { InjectedConnector } from '@web3-react/injected-connector'
import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected
} from '@web3-react/injected-connector'


import { Web3ReactProvider, useWeb3React, UnsupportedChainIdError } from '@web3-react/core'


import Layout from "../components/layout"
import Seo from "../components/seo"



const commaNumber = require('comma-number');
var Web3 = require('web3');
var Web3WsProvider = require('web3-providers-ws');
const injected = new InjectedConnector({ supportedChainIds: [1] })

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function getLibrary(provider) {
  const library = new Web3(window.ethereum)
  return library
}
var options = {
  timeout: 30000, // ms
  clientConfig: {
    // Useful to keep a connection alive
    keepalive: true,
    keepaliveInterval: 30000 // ms
  },

  // Enable auto reconnection
  reconnect: {
    auto: true,
    delay: 1000, // ms
    maxAttempts: 5,
    onTimeout: false
  }
};
const libraryFetch = new Web3(new Web3WsProvider('wss://speedy-nodes-nyc.moralis.io/5271b046033dffb583645ca9/eth/mainnet/ws', options))

const mainContractABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"GasForProcessingUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"LiquidationThresholdUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethReceived","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokensIntoLiqudity","type":"uint256"}],"name":"Liquified","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"iterations","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"claims","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lastProcessedIndex","type":"uint256"},{"indexed":true,"internalType":"bool","name":"automatic","type":"bool"},{"indexed":false,"internalType":"uint256","name":"gas","type":"uint256"},{"indexed":true,"internalType":"address","name":"processor","type":"address"}],"name":"ProcessedDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"SentDividends","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"pair","type":"address"},{"indexed":true,"internalType":"bool","name":"value","type":"bool"}],"name":"SetAutomatedMarketMakerPair","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdatedDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdatedUniswapV2Router","type":"event"},{"inputs":[],"name":"ETH_REWARDS_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"LIQUIDITY_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BUY_TRANSACTION_AMOUNT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_SELL_TRANSACTION_AMOUNT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_WALLET_AMOUNT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"SELL_FEE_INCREASE_FACTOR","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TOTAL_FEES","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"activateTrading","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"allowTransferBeforeTradingIsEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"automatedMarketMakerPairs","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"canTransferBeforeTradingIsEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"deadAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"dividendTokenBalanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"dividendTracker","outputs":[{"internalType":"contract ShibaETHDividendTracker","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromDividends","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"gasForProcessing","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getAccountDividendsInfo","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getAccountDividendsInfoAtIndex","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getClaimWait","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getGasForTransfer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLastProcessedIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumberOfDividendTokenHolders","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalDividendsDistributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"includeForFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromFees","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"liquidateTokensAtAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"gas","type":"uint256"}],"name":"processDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"pair","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"setAutomatedMarketMakerPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"setMaxBuyTransactionAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"setMaxSellTransactionAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"setMaxWalletAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"multiplier","type":"uint256"}],"name":"setSellFeeIncreaseFactor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tradingEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapV2Pair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapV2Router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"claimWait","type":"uint256"}],"name":"updateClaimWait","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updateDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newValue","type":"uint256"}],"name":"updateGasForProcessing","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"gasForTransfer","type":"uint256"}],"name":"updateGasForTransfer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newValue","type":"uint256"}],"name":"updateLiquidationThreshold","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updateUniswapV2Router","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"withdrawableDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}];
const mainContractAddress = "0x440c031d48cac6a2242521a2bcd0574bf74f6cac";

const currentDividendsContractABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":true,"internalType":"bool","name":"automatic","type":"bool"}],"name":"Claim","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"ClaimWaitUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"weiAmount","type":"uint256"}],"name":"DividendWithdrawn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"weiAmount","type":"uint256"}],"name":"DividendsDistributed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"ExcludedFromDividends","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"GasForTransferUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"MIN_TOKEN_BALANCE_FOR_DIVIDENDS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"accumulativeDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimWait","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"distributeDividends","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"dividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromDividends","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"excludedFromDividends","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"gasForTransfer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"getAccount","outputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"int256","name":"index","type":"int256"},{"internalType":"int256","name":"iterationsUntilProcessed","type":"int256"},{"internalType":"uint256","name":"withdrawableDividends","type":"uint256"},{"internalType":"uint256","name":"totalDividends","type":"uint256"},{"internalType":"uint256","name":"lastClaimTime","type":"uint256"},{"internalType":"uint256","name":"nextClaimTime","type":"uint256"},{"internalType":"uint256","name":"secondsUntilAutoClaimAvailable","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getAccountAtIndex","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLastProcessedIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumberOfTokenHolders","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"lastClaimTimes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastProcessedIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"gas","type":"uint256"}],"name":"process","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"account","type":"address"},{"internalType":"bool","name":"automatic","type":"bool"}],"name":"processAccount","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"account","type":"address"},{"internalType":"uint256","name":"newBalance","type":"uint256"}],"name":"setBalance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalDividendsDistributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newClaimWait","type":"uint256"}],"name":"updateClaimWait","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newGasForTransfer","type":"uint256"}],"name":"updateGasForTransfer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawDividend","outputs":[],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"withdrawableDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"withdrawnDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}];
let currentDividendsContractAddress = "0x946f7e8990683c882cb57f85cb250dc74ddee78f";

let currentDividendsContract = new libraryFetch.eth.Contract(currentDividendsContractABI, currentDividendsContractAddress)
let mainContract = new libraryFetch.eth.Contract(mainContractABI, mainContractAddress)
let contractFunctionData = mainContract.methods.claim().encodeABI()

export function useEagerConnect() {
  const { activate, active } = useWeb3React()

  const [tried, setTried] = useState(false)

  useEffect(() => {
    injected.isAuthorized().then((isAuthorized) => {
      if (isAuthorized) {
        activate(injected, undefined, true).catch(() => {
          setTried(true)
        })
      } else {
        setTried(true)
      }
    })
  }, []) // intentionally only running on mount (make sure it's only mounted once :))

  // if the connection worked, wait until we get confirmation of that to flip the flag
  useEffect(() => {
    if (!tried && active) {
      setTried(true)
    }
  }, [tried, active])

  return tried
}

function getErrorMessage(error) {
  if (error instanceof NoEthereumProviderError) {
    return 'No Wallet browser extension detected, install MetaMask on desktop or visit from a dApp browser on mobile.'
  } else if (error instanceof UnsupportedChainIdError) {
    return "You're connected to an unsupported network. Please switch to the Ethereum network"
  } else if (
    error instanceof UserRejectedRequestErrorInjected
  ) {
    return 'Please authorize this website to access your wallet.'
  } else {
    return 'An unknown error occurred.'
  }
}

export function useInactiveListener(suppress) {
  const { active, error, activate } = useWeb3React()

  useEffect(() => {
    const { ethereum } = window
    if (ethereum && ethereum.on && !active && !error && !suppress) {
      const handleConnect = () => {
        console.log("Handling 'connect' event")
        activate(injected)
      }
      const handleChainChanged = (chainId) => {
        console.log("Handling 'chainChanged' event with payload", chainId)
        activate(injected)
      }
      const handleAccountsChanged = (accounts) => {
        console.log("Handling 'accountsChanged' event with payload", accounts)
        if (accounts.length > 0) {
          activate(injected)
        }
      }
      const handleNetworkChanged = (networkId) => {
        console.log("Handling 'networkChanged' event with payload", networkId)
        activate(injected)
      }

      ethereum.on('connect', handleConnect)
      ethereum.on('chainChanged', handleChainChanged)
      ethereum.on('accountsChanged', handleAccountsChanged)
      ethereum.on('networkChanged', handleNetworkChanged)

      return () => {
        if (ethereum.removeListener) {
          ethereum.removeListener('connect', handleConnect)
          ethereum.removeListener('chainChanged', handleChainChanged)
          ethereum.removeListener('accountsChanged', handleAccountsChanged)
          ethereum.removeListener('networkChanged', handleNetworkChanged)
        }
      }
    }
  }, [active, error, suppress, activate])
}



function InnerDashboard() {

  const { connector, library, chainId, account, activate, deactivate, active, error } = useWeb3React()

  const currentConnector = "injected";

  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = React.useState()

  React.useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined)
    }
  }, [activatingConnector, connector])

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect()

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector)

  const [ethPrice, setEthPrice] = React.useState()

  React.useEffect(() => {
    if (!ethPrice) {
      fetch(`https://api.shibaeth.finance/get-eth-price`)
        .then(response => {
          return response.json()
        }).then(json => {
          setEthPrice(parseFloat(json), 10)
        }).catch(error => {

        })
    }

  }, [])


  const connectWallet = () => {
    setActivatingConnector(currentConnector)
    activate(injected)
  }

  const [tokenBalance, setTokenBalance] = React.useState()
  React.useEffect(() => {
    if (!!account && !!library) {
      let stale = false

      mainContract.methods.balanceOf(account).call()
        .then(function (result) {
          if (!stale) {
            setTokenBalance(libraryFetch.utils.toBN(result).toString())
          }

        }).catch(() => {
          if (!stale) {
            setTokenBalance(null)
          }
        })
      mainContract.events.Transfer({
        filter: {
          from: account
        },
      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          mainContract.methods.balanceOf(account).call()
            .then(function (result) {
              if (!stale) {
                setTokenBalance(libraryFetch.utils.toBN(result).toString())
              }

            }).catch(() => {
              if (!stale) {
                setTokenBalance(null)
              }
            })
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });
      mainContract.events.Transfer({
        filter: {
          to: account
        },

      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          mainContract.methods.balanceOf(account).call()
            .then(function (result) {
              if (!stale) {
                setTokenBalance(libraryFetch.utils.toBN(result).toString())
              }

            }).catch(() => {
              if (!stale) {
                setTokenBalance(null)
              }
            })
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });

      return () => {
        stale = true
        setTokenBalance(undefined)
      }
    }
  }, [account, library])

  console.log(tokenBalance);
  console.log(libraryFetch.utils.toWei("200000", 'ether'))

  const [currentDividends, setCurrentDividends] = React.useState()
  React.useEffect(() => {
    if (!!account && !!library) {
      let stale = false
      currentDividendsContract.methods.withdrawnDividendOf(account).call()
        .then(function (result) {
          if (!stale) {
            setCurrentDividends(libraryFetch.utils.toBN(result).toString())
          }
        }).catch(() => {
          if (!stale) {
            setCurrentDividends(null)
          }
        });
      currentDividendsContract.events.DividendWithdrawn({
        filter: {
          to: account
        },
      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          currentDividendsContract.methods.withdrawnDividendOf(account).call()
            .then(function (result) {
              if (!stale) {
                setCurrentDividends(libraryFetch.utils.toBN(result).toString())
              }
            }).catch(() => {
              if (!stale) {
                setCurrentDividends(null)
              }
            });
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });
      currentDividendsContract.events.DividendsDistributed({
        filter: {
          to: account
        },
      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          currentDividendsContract.methods.withdrawnDividendOf(account).call()
            .then(function (result) {
              if (!stale) {
                setCurrentDividends(libraryFetch.utils.toBN(result).toString())
              }
            }).catch(() => {
              if (!stale) {
                setCurrentDividends(null)
              }
            });
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });


      return () => {
        stale = true
        setCurrentDividends(undefined)
      }
    }
  }, [account, library, chainId]) // ensures refresh if referential identity of library doesn't change across chainIds


  const [withdrawableDividends, setWithdrawableDividends] = React.useState()
  const claimClick = () => {
    (window).global = window;
    global.Buffer = global.Buffer || require('buffer').Buffer;
    global.process = require('process');
    if (!!account && !!library) {
      library.eth.sendTransaction({
        from: account,
        to: mainContractAddress,
        data: contractFunctionData
      }, function (err, result) {
        if (!err)
          console.log(result)
      })
    }
  }
  React.useEffect(() => {
    if (!!account && !!library) {
      let stale = false

      currentDividendsContract.methods.withdrawableDividendOf(account).call()
        .then(function (result) {
          if (!stale) {
            setWithdrawableDividends(libraryFetch.utils.toBN(result).toString())
          }

        }).catch(() => {
          if (!stale) {
            setWithdrawableDividends(null)
          }
        })
      currentDividendsContract.events.DividendWithdrawn({
        filter: {
          to: account
        },
      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          currentDividendsContract.methods.withdrawableDividendOf(account).call()
            .then(function (result) {
              if (!stale) {
                setWithdrawableDividends(libraryFetch.utils.toBN(result).toString())
              }

            }).catch(() => {
              if (!stale) {
                setWithdrawableDividends(null)
              }
            })
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });
      currentDividendsContract.events.DividendsDistributed({
        filter: {
          to: account
        },

      }, function (error, event) { })
        .on("connected", function (subscriptionId) {

        })
        .on('data', function (event) {
          currentDividendsContract.methods.withdrawableDividendOf(account).call()
            .then(function (result) {
              if (!stale) {
                setWithdrawableDividends(libraryFetch.utils.toBN(result).toString())
              }

            }).catch(() => {
              if (!stale) {
                setWithdrawableDividends(null)
              }
            })
        })
        .on('changed', function (event) {

        })
        .on('error', function (error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.

        });

      return () => {
        stale = true
        setWithdrawableDividends(undefined)
      }
    }
  }, [account, library]) // ensures refresh if referential identity of library doesn't change across chainIds
  


  return (
    <div>
      {!!error &&
        <div className="">
          <div className="rounded-md bg-red-50 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">{getErrorMessage(error)}</h3>
              </div>
            </div>
          </div>
        </div>

      }


      <div className="bg-white overflow-hidden shadow rounded-lg border border-gray-100">
        <div className="p-5 sm:p-6 md:p-7 lg:p-8 xl:p-10 border-b border-gray-200">
          <div className="sm:flex items-center justify-between">

            <div className="mb-4 sm:mb-0">
              <h1 className="text-2xl md:text-3xl xl:text-4xl font-semibold">Dashboard</h1>
              <p className="text-sm md:text-base lg:text-lg md:mt-1 text-gray-700">Check & claim your ETH Dividends</p>
            </div>

            {active ? (
              <div className="text-gray-800 flex items-center font-medium text-base md:text-lg ">
                <div className="flex-shrink-0 flex items-center justify-center h-10 md:h-12 w-10 md:w-12 rounded-full bg-indigo-100 text-indigo-500 mr-3">
                  <UserIcon className="h-5 md:h-6 w-5 md:w-6" aria-hidden="true" />
                </div>
                <div>
                  <p className="text-xs md:text-sm font-medium tracking-wider text-indigo-500 uppercase">Connected Wallet</p>
                  {account === null
                    ? '-'
                    : account
                      ? <div>

                        {account.substring(0, 4)}...{account.substring(account.length - 4)}
                      </div>
                      : ''}
                </div>
              </div>
            ) :
              (<div className="flex items-center">
                <button
                  onClick={connectWallet}
                  type="button"
                  className="flex items-center flex-shrink-0 text-white bg-indigo-600 transform hover:bg-indigo-500  px-4 py-2 lg:px-8 lg:py-4 text-xs md:text-sm font-bold tracking-wider rounded-full uppercase focus:outline-none leading-tight space-x-1 lg:space-x-1.5"
                ><UserIcon className="w-6 h-6 mr-1.5" />
                  Connect Wallet
                </button>
              </div>)}

          </div>



        </div>
        <div className="md:grid grid-cols-2">
          <div className="p-5 sm:p-6 md:p-7 lg:p-8 xl:p-10"><div className="text-gray-900 flex items-center">
            <div>
              <p className="text-sm md:text-base font-medium tracking-wider text-indigo-500 uppercase md:mb-1">ShibaETH Balance</p>
              <div className="font-medium text-2xl md:text-2xl lg:text-4xl flex items-center">
                {
                  tokenBalance
                    ? commaNumber(parseFloat(libraryFetch.utils.fromWei(tokenBalance, 'ether')).toFixed(2), ',', '.')
                    : <span className="bg-gray-300 rounded-full animate-pulse"><span className="opacity-0">100,000,000.00</span></span>
                }
                <span className="text-gray-700 font-normal text-base md:text-xl ml-2">SHIBAETH</span>
              </div>
              <div className="text-xs md:text-sm mt-0.5 md:mt-1">
                {
                  tokenBalance
                    ? (
                      <div>
                        {new libraryFetch.utils.BN(tokenBalance).lte(new libraryFetch.utils.BN(libraryFetch.utils.toWei("200000", 'ether')))
                          ? <span className="text-red-600 flex items-start">
                            <ExclamationCircleIcon className="w-4 h-4 mr-1 mt-0.5 flex-shrink-0" />
                            <span>You do not have enough ShibaETH tokens to qualify for dividend distribution. You need to hold a minimum of <strong>200,000 tokens</strong></span>

                          </span>
                          : <span className="text-green-600 flex items-start">
                            <CheckCircleIcon className="w-4 h-4 mr-1 mt-0.5 flex-shrink-0" />
                            <span>You have more than 200,000 tokens and you qualify for the dividend distribution!</span>

                          </span>}
                      </div>

                    )
                    : (
                      <span className="bg-gray-300 rounded-full animate-pulse inline-block">
                        <span className="text-green-600 flex items-start opacity-0">
                          <CheckCircleIcon className="w-4 h-4 mr-1 mt-0.5" />
                          <span>You have more than 200,000 tokens and you qualify for the dividend distribution!</span>
                        </span>
                      </span>

                    )

                }
              </div>
            </div>
          </div>
            <div className="text-gray-900 flex items-center font-medium  mt-4 sm:mt-6 md:mt-8">
              <div>
                <p className="text-sm md:text-base font-medium tracking-wider text-indigo-500 uppercase md:mb-1">Total Claimed Dividends</p>
                <div className="text-2xl md:text-2xl lg:text-4xl flex items-center">{
                  currentDividends
                    ? parseFloat(libraryFetch.utils.fromWei(new libraryFetch.utils.BN(currentDividends).toString(), 'ether')).toFixed(10)
                    : <span className="bg-gray-300 rounded-full animate-pulse"><span className="opacity-0">0.0000000000</span></span>
                }<span className="text-gray-700 font-normal text-base md:text-xl ml-2">ETH</span></div>
                <div className="text-sm md:text-base text-gray-500 block items-center font-normal mx-auto lg:mx-0 leading-tight md:leading-tight mt-0.5 md:mt-1">
                  {ethPrice && currentDividends
                    ?
                    <span>~ ${parseFloat(libraryFetch.utils.fromWei(new libraryFetch.utils.BN(currentDividends).mul(new libraryFetch.utils.BN(ethPrice)).toString(), 'ether')).toFixed(2)}</span>
                    :
                    <span className="bg-gray-300 rounded-full animate-pulse"><span className="opacity-0">~ $00000</span></span>}
                  <span className="ml-1">USD</span>
                </div>
              </div>
            </div>

          </div>
          <div className="p-5 sm:p-6 md:p-7 lg:p-8 xl:p-10 bg-gray-50 md:bg-white">

            <div className="md:bg-gray-50 md:rounded-lg md:p-7 lg:p-8 xl:p-10 flex items-center h-full">

              <div>
                <p className="text-sm md:text-base font-medium tracking-wider text-indigo-500 uppercase md:mb-1">Available dividends to claim</p>
                <div className="mb-2 md:mb-3">
                  <div className="text-xl md:text-2xl lg:text-3xl flex items-center font-medium ">
                    {
                      withdrawableDividends
                        ? parseFloat(libraryFetch.utils.fromWei(withdrawableDividends), 'ether').toFixed(10)
                        : <span className="bg-gray-300 rounded-full animate-pulse"><span className="opacity-0">0.0000000000</span></span>
                    }

                    <span className="text-gray-700 font-normal text-base md:text-xl ml-2">ETH</span></div>
                  <div className="text-sm md:text-base text-gray-500 block items-center font-normal mx-auto lg:mx-0 leading-tight md:leading-tight mt-0.5 md:mt-1">
                    {ethPrice && withdrawableDividends
                      ?
                      <span>~ ${parseFloat(libraryFetch.utils.fromWei(new libraryFetch.utils.BN(withdrawableDividends).mul(new libraryFetch.utils.BN(ethPrice)).toString(), 'ether')).toFixed(2)}</span>
                      :
                      <span className="bg-gray-300 rounded-full animate-pulse"><span className="opacity-0">~ $00.00</span></span>}
                    <span className="ml-1">USD</span>
                  </div>
                </div>
                {
                  withdrawableDividends === "0" || withdrawableDividends === null || !withdrawableDividends
                    ? <button
                      type="button"
                      className="flex items-center flex-shrink-0 transform  px-4 py-2 lg:px-8 lg:py-4 text-xs md:text-sm font-bold tracking-wider rounded-full uppercase focus:outline-none leading-tight space-x-1 lg:space-x-1.5 text-gray-500 bg-gray-200 cursor-not-allowed"
                      disabled>
                      <CashIcon className="w-6 h-6 mr-1.5" />
                      Claim Dividends
                    </button>
                    : <button
                      type="button"
                      className="flex items-center flex-shrink-0 text-white bg-indigo-600 transform hover:bg-indigo-500  px-4 py-2 lg:px-8 lg:py-4 text-xs md:text-sm font-bold tracking-wider rounded-full uppercase focus:outline-none leading-tight space-x-1 lg:space-x-1.5"
                      onClick={claimClick}><CashIcon className="w-6 h-6 mr-1.5" />Claim Dividends</button>
                }
              </div>

            </div>


          </div>

        </div>
        <div className="p-5 sm:p-6 md:p-7 lg:p-8 xl:p-10 md:border-t md:border-gray-200 text-gray-700 text-xs md:text-sm">
          Your dividends are auto-claimed at certain time intervals (depending on ShibaETH transaction volume) or when you send/receive ShibaETH tokens from your wallet. You may also claim manually using the button above.
        </div>

      </div>




    </div>
  )
}
const DashboardPage = () => {

  return (
    <Layout>
      <Seo

        title="Dashboard"

      />
      <div className="relative bg-white overflow-hidden mb-6 md:mb-12">
        <div className="absolute inset-0" aria-hidden="true">
          <svg
            className="absolute top-0 left-1/2 h-auto w-full max-w-2xl transform translate-x-1/2 -ml-36 lg:-ml-36 -translate-y-8"
            width={640}
            height={784}
            fill="none"
            viewBox="0 0 640 784"
          >
            <defs>
              <pattern
                id="9ebea6f4-a1f5-4d96-8c4e-4c2abf658047"
                x={118}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect y={72} width={640} height={640} className="text-gray-50" fill="currentColor" />
            <rect x={118} width={404} height={784} fill="url(#9ebea6f4-a1f5-4d96-8c4e-4c2abf658047)" />
          </svg>
        </div>

        <div className="container py-8 sm:py-12 lg:py-20 relative z-10">
          <Web3ReactProvider getLibrary={getLibrary}>
            <InnerDashboard />
          </Web3ReactProvider>



        </div>
      </div>


    </Layout>
  )
}

export default DashboardPage

